export default __webpack_public_path__ + "static/media/send_invoice.a247d070.png";